module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/fronts/m2-a1d756ebb17813875073d0bd8ec014a8.png";